import { PeekButton, PeekDialog, PeekDialogActions, PeekDialogContent, PeekGrid, } from "@piiqtechnologies/ui-components";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { useCreateMagicButton, useError, useLoader, useNotification, useRefetch } from "@piiqtechnologies/ui-lib";
import { AddMagicButtonFormFields, AddMagicButtonFormInitialValues, AddMagicButtonFormValidationSchema, } from "./AddMagicButtonForm";
import { MultiColumnFormFields } from "@components/common/form/FormFields";
import { MagicButtonTemplatePreview } from "./MagicButtonTemplatePreview";
import { MagicButtonTemplateSelector } from "./magic-button-template-selector";
import { AddMagicButtonConfirmation } from "./AddMagicButtonConfirmation";
export const AddMagicButtonForm = ({ onClose }) => {
    const [createMagicButton, magicButtonCreated, inProgress, error] = useCreateMagicButton();
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const { setNotification } = useNotification();
    const [selectedMagicButtonTemplate, setMagicButtonTemplate] = useState(null);
    const [onConfirmationPage, setOnConfirmationPage] = useState(false);
    const [formValues, setFormValues] = useState({});
    useEffect(() => {
        setLoader(inProgress, "creatingMagicButton");
        return () => setLoader(false, "creatingMagicButton");
    }, [inProgress]);
    useEffect(() => {
        if (error) {
            setError(error === null || error === void 0 ? void 0 : error.message);
        }
    }, [error]);
    useEffect(() => {
        if (magicButtonCreated) {
            setNotification(intl.formatMessage(messages.magicButtonSuccessCreation));
            onClose();
            setRefetch();
        }
    }, [magicButtonCreated]);
    const handleConfirmationPage = (values) => {
        setFormValues(values);
        setOnConfirmationPage(true);
    };
    const handleSubmit = () => {
        const values = formValues;
        values.community._id = values.community.id;
        delete values.community.id;
        delete values.vendor;
        createMagicButton(Object.assign(Object.assign({}, values), { template: {
                _id: selectedMagicButtonTemplate._id,
                templateName: selectedMagicButtonTemplate.templateName,
                vendorName: selectedMagicButtonTemplate.vendorName,
            } }));
    };
    return (React.createElement(PeekDialog, { disablePortal: true, maxWidth: "lg", hasCloseIcon: true, "data-testid": "magic-buttons-form", fullWidth: true, title: intl.formatMessage(messages.magicButtonTitle), open: true, onClose: onClose },
        React.createElement(Formik, { initialValues: AddMagicButtonFormInitialValues, validationSchema: AddMagicButtonFormValidationSchema(), onSubmit: handleConfirmationPage }, ({ values }) => {
            return (React.createElement(Form, null,
                React.createElement(PeekDialogContent, null,
                    onConfirmationPage && (React.createElement(AddMagicButtonConfirmation, { onConfirm: handleSubmit, onCancel: () => setOnConfirmationPage(false) })),
                    React.createElement(PeekGrid, { display: "flex", direction: "row" },
                        React.createElement(PeekGrid, { xs: 12, position: "sticky", top: 0 },
                            React.createElement(MultiColumnFormFields, { fullWidth: true, fields: AddMagicButtonFormFields() }),
                            values.vendor && (React.createElement(MagicButtonTemplateSelector, { selectedTemplate: selectedMagicButtonTemplate, templates: values.vendor.templates, onSelect: setMagicButtonTemplate })),
                            React.createElement(PeekDialogActions, { sx: { px: 0 } },
                                React.createElement(PeekButton, { disabled: !selectedMagicButtonTemplate, type: "submit", color: "primary", variant: "contained", size: "large", fullWidth: true }, intl.formatMessage(messages.magicButtonTitle)))),
                        React.createElement(MagicButtonTemplatePreview, { magicButtonTemplate: selectedMagicButtonTemplate })))));
        })));
};
export default AddMagicButtonForm;
